<template>
  <div>
    <div style="display: none">
      <div id="report_holder"></div>
    </div>
    <el-row>
      <el-col :span="11">
        <el-row>
          <el-select
            v-model="whsettingTopId"
            placeholder="请选择"
            @change="selectWhsetting"
          >
            <el-option
              v-for="item in whsettingListTop"
              :key="item.Id + '_top'"
              :label="item.Name"
              v-model="item.Id"
            ></el-option>
          </el-select>
        </el-row>
        <el-row>
          <div class="number">{{ whnumber }}</div>
        </el-row>
        <el-row>
          <el-col :span="3" :offset="3">
            <el-button
              type="primary"
              @click.native="addGross"
              :loading="editLoading"
            >
              过毛
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click.native="addTare"
              :loading="editLoading"
            >
              过皮
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click.native="saveForm()"
              :loading="editLoading"
            >
              保存
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button
              v-show="showPhotoBtn"
              type="primary"
              @click.native="getShot(0)"
              :loading="editLoading"
            >
              拍照
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click.native="cancel">取消</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <h3>过磅信息</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-form
            :model="editForm"
            label-width="100px"
            :rules="editFormRules"
            ref="editForm"
            class="editForm"
          >
            <el-row>
              <el-col :span="24">
                <div class="typer" v-show="showTyper != 0">
                  <!-- ③输入键盘 -->
                  <ul v-show="showTyper == 1">
                    <!-- ④省的输入 -->
                    <el-button
                      class="typer-pro"
                      v-for="(item, id) in provinces"
                      :key="id"
                      :class="{ 'is-closeType': item === '关闭' }"
                      @click="input(item)"
                    >
                      {{ item }}
                    </el-button>
                  </ul>
                  <ul v-show="showTyper == 2">
                    <!-- ⑤字母数字的输入 -->
                    <el-button
                      class="typer-num"
                      v-for="(item, id) in keyNums"
                      :key="id"
                      :class="{
                        'is-A': item === 'A',
                        'is-OK': item === '确认',
                        'is-Del': item === '删除',
                      }"
                      @click="input(item)"
                    >
                      {{ item }}
                    </el-button>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <!-- 从这里开始复制 -->
            <el-row>
              <el-col :span="12">
                <el-form-item label="过磅单号">
                  <el-input v-model="editForm.Code" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="车牌号">
                  <template>
                    <el-select
                      v-model="editForm.License"
                      filterable
                      remote
                      :remote-method="remoteMethod"
                      allow-create
                      default-first-option
                      @change="changeLicense"
                      @click.native="remoteMethod('')"
                      placeholder="请选择车牌"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.Value + '_carcode'"
                        :label="item.Value"
                        :value="item.Value"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <div>
                  <el-button
                    type="primary"
                    slot="append"
                    @click="onTypewriting()"
                  >
                    键盘
                  </el-button>
                </div>
              </el-col>
              <el-col :span="2">
                <div>
                  <el-button type="info" slot="append" @click="clearNum">
                    重置
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="毛重">
                  <el-input
                    v-model="editForm.GrossWeight"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物资">
                  <template>
                    <el-select
                      v-model="editForm.MatID"
                      filterable
                      placeholder="请选择"
                      @change="selectMaterial"
                    >
                      <el-option
                        v-for="item in materialList"
                        :key="item.Id + '_addmat'"
                        :label="
                          item.Name +
                          (item.MatGrade == null ? '' : item.MatGrade)
                        "
                        v-model="item.Id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="皮重">
                  <el-input
                    v-model="editForm.TareWeight"
                    @input="NetWeightCount"
                  >
                    <template slot="append">
                      <el-button class="pd-5" @click="getLastTareWeight()">
                        获取上车皮重
                      </el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="仓库">
                  <template>
                    <el-select
                      v-model="editForm.WarehouseID"
                      filterable
                      placeholder="请选择"
                      @change="selectWarehouse"
                      width="100%"
                    >
                      <el-option
                        v-for="item in filteredWarehouses"
                        :key="item.Id + '_addwh'"
                        :label="item.Name"
                        v-model="item.Id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="扣重">
                  <el-input
                    v-model="editForm.BuckleWeight"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="供应商">
                  <template>
                    <el-select
                      v-model="editForm.SupplierName"
                      filterable
                      allow-create
                      default-first-option
                      placeholder="请选择"
                      @change="selectSupplier"
                      :clearable="true"
                    >
                      <el-option
                        v-for="item in filteredSuppliers"
                        :key="item.Id + '_addgys'"
                        :label="item.Name"
                        v-model="item.Name"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="扣除率">
                  <el-input
                    v-model="editForm.DeductionRate"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运输单位">
                  <template>
                    <el-select
                      v-model="editForm.TransportName"
                      filterable
                      allow-create
                      default-first-option
                      placeholder="请选择"
                      @change="selectTransport"
                      :clearable="true"
                    >
                      <el-option
                        v-for="item in transportList"
                        :key="item.Id + '_addys'"
                        :label="item.Name"
                        v-model="item.Name"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="净重">
                  <el-input v-model="editForm.NetWeight" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产地">
                  <template>
                    <el-select
                      v-model="editForm.PlaceOfOriginName"
                      filterable
                      allow-create
                      default-first-option
                      placeholder="请选择"
                      @change="selectPlaceOfOrigin"
                      :clearable="true"
                    >
                      <el-option
                        v-for="item in placeOfOriginList"
                        :key="item.Id + '_addcd'"
                        :label="item.Name"
                        v-model="item.Name"
                      ></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="折方系数">
                  <el-input v-model="editForm.CubRate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="折方">
                  <el-input v-model="editForm.DiscountQuantity"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="对方毛重">
                  <el-input
                    v-model="editForm.OtherGrossWeight"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="对方皮重">
                  <el-input
                    v-model="editForm.OtherTareWeight"
                    @input="NetWeightCount"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="对方净重">
                  <el-input v-model="editForm.OtherNetWeight"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="净重差异">
                  <el-input v-model="editForm.NetWeightDifference"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input v-model="editForm.Remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :v-if="shotGList.length > 0 ? true : false"
                :span="12"
                v-for="(item, i) in shotGList"
                :key="i + 'shotG'"
              >
                <img
                  :id="'shotG_' + i"
                  :src="item.FilePath"
                  style="width: 270px; height: 180px; border: 1px solid"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :v-if="shotTList.length > 0 ? true : false"
                :span="12"
                v-for="(item, i) in shotTList"
                :key="i + 'shotT'"
              >
                <img
                  :id="'shotT_' + i"
                  :src="item.FilePath"
                  style="width: 270px; height: 180px; border: 1px solid"
                />
              </el-col>
            </el-row>
            <!-- 从这里结束 -->
          </el-form>
        </el-row>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-row>
          <el-col
            :span="12"
            v-for="(item, i) in VideoUrlList"
            :key="i + 'video'"
          >
            <img
              :id="'video_' + i"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>

        <el-form label-width="50px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="车号">
                <el-input
                  v-model="License"
                  width="100px"
                  @change="getWeighingIn(1)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-form-item label="状态">
                <el-select
                  v-model="Status"
                  placeholder="请选择状态"
                  @change="getWeighingIn(1)"
                >
                  <el-option label="所有" :value="-1"></el-option>
                  <el-option label="已过毛" :value="0"></el-option>
                  <el-option label="已过皮" :value="100"></el-option>
                  <el-option label="完成" :value="200"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-form-item label="磅秤">
                <el-select
                  v-model="WeightID"
                  placeholder="请选择"
                  :clearable="true"
                  @change="getWeighingIn(1)"
                >
                  <el-option
                    v-for="item in whsettingListSelect"
                    :key="item.Id + '_bc'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" :offset="1">
              <el-button @click="getWeighingIn(1)">查询</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-row
          class="overflow-auto"
          :gutter="10"
          :style="VideoUrlList.length > 0 ? 'height: 55vh' : 'height: 75vh'"
        >
          <el-col
            :span="11"
            v-for="item in WeighingIn"
            :key="item.Id + '_weiin'"
            class="rigth-card"
          >
            <el-card class="rigth-card">
              <el-form>
                <el-row type="flex" justify="space-between">
                  <el-col :span="16">
                    <el-form-item label="车牌">{{ item.License }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item>
                      <el-button
                        type="success"
                        size="mini"
                        @click="
                          () => {
                            currentRow = item;
                            PrintCompleteRecive();
                          }
                        "
                        :loading="editLoading"
                      >
                        过皮打印入库
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col :span="12">
                  <el-form-item label="物资">
                    {{ item.MatName }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="仓库">
                    {{ item.WarehouseName }}
                  </el-form-item>
                </el-col>
                <el-col type="flex" justify="space-between" class="weigth">
                  <div>
                    <div>毛重</div>
                    <div>{{ item.GrossWeight }}</div>
                  </div>
                  <div>
                    <div>皮重</div>
                    <div>{{ item.TareWeight }}</div>
                  </div>
                  <div>
                    <div>净重</div>
                    <div>{{ item.NetWeight }}</div>
                  </div>
                </el-col>
                <el-form-item label="供应商">
                  {{ item.SupplierName }}
                </el-form-item>
                <el-form-item label="运输单位">
                  {{ item.TransportName }}
                </el-form-item>
                <el-form-item label="建单时间">
                  {{ item.CreateTime }}
                </el-form-item>
                <el-row type="flex" justify="space-between">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="
                      () => {
                        sels.push(item);
                        deleteWeighingIn();
                      }
                    "
                    :loading="editLoading"
                  >
                    删除
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="
                      () => {
                        currentRow = item;
                        handleEdit();
                      }
                    "
                    :loading="editLoading"
                  >
                    修改
                  </el-button>
                  <el-button
                    type="info"
                    size="mini"
                    @click="
                      () => {
                        print(item.Id);
                      }
                    "
                    :loading="editLoading"
                  >
                    打印
                  </el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="
                      () => {
                        currentRow = item;
                        handleComplete();
                      }
                    "
                    :loading="editLoading"
                  >
                    完成
                  </el-button>
                </el-row>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//引入whsetting.js的所有export的对象,并起别名为api,通过api.***访问成员
import { BaseApiUrl, getTaskListPage } from "../../api/api";
import * as api from "../../api/weighingIn";
import originJSONP from "jsonp";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { VueJsonp } from "vue-jsonp";
import printJS from "print-js";
import { runReport } from "../../api/viewReport";
export default {
  components: { Toolbar },
  data() {
    return {
      phoneNo: "",
      lastTareWeight: 0,
      lastTareTime: null,
      showTyper: 0, // 输入法的值，0表示不显示，1表示显示省输入键盘，2表示显示数字字母输入键盘
      provinces: [
        "京",
        "沪",
        "浙",
        "苏",
        "粤",
        "鲁",
        "晋",
        "冀", // 省
        "豫",
        "川",
        "渝",
        "辽",
        "吉",
        "黑",
        "皖",
        "鄂",
        "津",
        "贵",
        "云",
        "桂",
        "琼",
        "青",
        "新",
        "藏",
        "蒙",
        "宁",
        "甘",
        "陕",
        "闽",
        "赣",
        "湘",
        "关闭",
      ],
      keyNums: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9", // 数字字母
        "Q",
        "W",
        "E",
        "R",
        "T",
        "Y",
        "U",
        "I",
        "O",
        "P",
        "A",
        "S",
        "D",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "Z",
        "X",
        "C",
        "V",
        "B",
        "N",
        "M",
        "确认",
        "删除",
      ],
      carNumber: "", // 输入的值
      wechatCode: "",
      wechatStatus: "",

      buttonList: [], //按钮列表
      whsettingListSelect: [], //磅秤列表
      whsettingListTop: [], //磅秤列表
      whsettingTopId: "",
      whsetting: {}, //当前选择磅秤
      VideoUrlList: [], //当前视频地址
      socket: [],
      editFormRules: {
        MatName: [
          { required: true, message: "请输入物资名称", trigger: "blur" },
        ],
      },
      total: 0,
      page: 1,
      pageSize: 50,
      sels: [], //列表选中列
      editForm: {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        License: "",
      }, //编辑数据
      WeighingIn: [], //过磅数据列表
      currentRow: {}, //当前选择列
      whnumber: 0,
      materialList: [], //物资列表
      warehouseList: [], //仓库列表
      supplierList: [], //供应商列表
      transportList: [], //运输单位列表
      placeOfOriginList: [], //产地列表
      editLoading: false,
      isEdit: false,
      License: "", //查询车牌
      Status: -1, //查询进料过磅状态
      WeightID: "", //查询过磅磅秤ID
      weightInAuto: null, //磅秤数据读取线程
      outtime: 3000,
      loading: false,
      options: [],
      weightCameraInAuto: null, //摄像头识别线程
      shotGList: [], //毛重拍照List
      shotTList: [], //皮重拍照片List
      lastLicense: "", //上一次车牌识别的车牌
      showPhotoBtn: false, //是否显示拍照按钮
      weightSocket: null, //磅秤Socket对象
      cameraSocket: null, //车牌识别Socket对象
      weightTimeoutObj: null, //磅秤心跳检测包
      cameraTimeoutObj: null, //摄像头心跳检测包
      videoTimeoutObj: null, //视频心跳检测包
    };
  },
  computed: {
    filteredSuppliers() {
      // 如果 MatID 无效，直接返回全部供应商
      if (!this.editForm.MatID || this.editForm.MatID <= 0) {
        return this.supplierList;
      }

      // 查找匹配的材料
      const material = this.materialList.find(
        (k) => k.Id === this.editForm.MatID
      );
      if (!material || !material.Remark) {
        return this.supplierList;
      }

      // 过滤供应商
      const filtered = this.supplierList.filter(
        (z) => z.Remark && z.Remark.includes(material.Remark)
      );
      return filtered.length > 0 ? filtered : this.supplierList;
    },
    filteredWarehouses() {
      // 1. 检查 MatID 是否有效
      if (!this.editForm.MatID || this.editForm.MatID <= 0) {
        return this.warehouseList;
      }

      // 2. 查找对应的材料
      const material = this.materialList.find(
        (k) => k.Id === this.editForm.MatID
      );
      if (!material || !material.Remark) {
        return this.warehouseList;
      }

      // 3. 过滤仓库列表
      const matchedWarehouses = this.warehouseList.filter(
        (z) => z.Remark && material.Remark && z.Remark === material.Remark
      );

      // 4. 返回符合条件的仓库或全部仓库
      return matchedWarehouses.length > 0
        ? matchedWarehouses
        : this.warehouseList;
    },
  },
  methods: {
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getWeighingIn();
    },
    handleDel() {},
    handleEdit() {
      this.editForm = JSON.parse(JSON.stringify(this.currentRow));
      this.shotGList = [];
      this.shotTList = [];
      //this.editForm = this.currentRow;
      if (!!this.currentRow.GrossImgPath) {
        var UploadUrls = this.currentRow.GrossImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (!!this.currentRow.TareImgPath) {
        var UploadUrls = this.currentRow.TareImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.editForm = {
        GrossWeight: 0,
        TareWeight: 0,
        NetWeight: 0,
        Status: 0,
        WeightType: 0,
        License: "",
      };
      this.shotGList = [];
      this.shotTList = [];
    },
    deleteWeighingIn() {
      this.editLoading = true;
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          let para = this.sels.map((item) => item.Id);

          api.batchDeleteWeighingIn(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getWeighingIn();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.editLoading = false;
        });
    },
    //完成
    handleComplete() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .completeWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getWeighingIn();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //打印完成入库
    PrintCompleteRecive() {
      if (Number(this.whnumber) <= 0) {
        this.$message({
          message: "磅秤数值为0！",
          type: "error",
        });
        return;
      }
      var whType = 1;
      this.editLoading = true;
      this.editForm = this.currentRow;
      this.editForm.TareWeight = this.whnumber;
      if (Number(this.editForm.TareWeight) <= 0) {
        this.$message({
          message: "过皮并打印时皮重必须大于0",
          type: "error",
        });
        return;
      }
      if (Number(this.editForm.GrossWeight) <= 0) {
        this.$message({
          message: "过皮并打印时毛重必须大于0",
          type: "error",
        });
        return;
      }
      this.NetWeightCount();
      var opts = { timeout: 6000 };
      if (this.whsetting.Photos && this.whsetting.CameraUrl) {
        originJSONP(
          this.whsetting.CameraUrl +
            "/Shot?cameraIDList=" +
            this.whsetting.Photos,
          opts,
          (err, data) => {
            if (data && data.length > 0) {
              if (whType == 0) {
                this.shotGList = [];
              } else {
                this.shotTList = [];
              }
              if (whType == 0) {
                this.editForm.GrossImgPath = JSON.stringify(data);
              } else {
                this.editForm.TareImgPath = JSON.stringify(data);
              }
              data.map((e) => {
                e.FilePath = BaseApiUrl + "/" + e.FilePath;
                if (whType == 0) {
                  this.shotGList.push(e);
                } else {
                  this.shotTList.push(e);
                }
              });
            }
            this.PrintCompleteReciveSave();
          }
        );
      } else {
        this.PrintCompleteReciveSave();
      }
    },
    PrintCompleteReciveSave() {
      let para = Object.assign({}, this.editForm);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .printCompleteRecive(para)
        .then((res) => {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
          let syles = "";
          if (document.styleSheets.length > 1) {
            for (let i = document.styleSheets.length - 1; i >= 0; i--) {
              if (document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0) {
                let rulesList = document.styleSheets[i].cssRules;
                for (let j = 0; j < rulesList.length; j++) {
                  syles += rulesList[j].cssText;
                }
                break;
              }
            }
          }
          printJS({
            printable: "report_holder",
            type: "html",
            header: null,
            targetStyles: ["*"],
            style: syles,
            scanStyles: false,
          });
        })
        .finally(() => {
          this.cancel();
          this.getWeighingIn();
          this.editLoading = false;
        });
    },
    print(Id) {
      this.editLoading = true;
      let para = {
        id: Id,
        printId: this.whsetting.PrintID,
      };
      api
        .getPrintContent(para)
        .then((res) => {
          if (res.data.success) {
            runReport(
              res.data.response.PrintEntity,
              res.data.response.PrintModel
            );
            let syles = "";
            if (document.styleSheets.length > 1) {
              for (let i = document.styleSheets.length - 1; i >= 0; i--) {
                if (
                  document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0
                ) {
                  let rulesList = document.styleSheets[i].cssRules;
                  for (let j = 0; j < rulesList.length; j++) {
                    syles += rulesList[j].cssText;
                  }
                  break;
                }
              }
            }
            printJS({
              printable: "report_holder",
              type: "html",
              header: null,
              targetStyles: ["*"],
              style: syles,
              scanStyles: false,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingIn();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //获取过磅列表
    getWeighingIn(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        license: this.License,
        status: this.Status,
        weightID: this.WeightID,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getWeighingInListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.WeighingIn = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    //获取磅秤列表
    getWhsettingDetail() {
      let para = {
        key: 0,
      };
      this.listLoading = true;
      api.getWhsettingDetail(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.whsettingListSelect = res.data.response;
          this.whsettingListTop = res.data.response;
          if (window.localStorage.WhIn1Com) {
            this.whsetting = JSON.parse(window.localStorage.WhIn1Com);
            this.whsettingTopId = this.whsetting.Id;
          } else {
            this.whsetting = res.data.response[0];
            this.whsettingTopId = res.data.response[0].Id;
          }
          if (
            this.whsetting.VideoUrl != "" &&
            this.whsetting.VideoUrl != null
          ) {
            this.VideoUrlList = this.whsetting.VideoUrl.split(",");
          } else {
            this.VideoUrlList = [];
          }
          this.initSocket(-1);
          if (this.whsetting.CameraUrl && this.whsetting.Cameras) {
            this.getCamera();
          }
          if (this.whsetting.Photos && this.whsetting.CameraUrl) {
            this.showPhotoBtn = true;
          } else {
            this.showPhotoBtn = false;
          }
          this.getweight();
        }
      });
    },
    //获取进料过磅基础信息
    GetWeighingInBaseData() {
      this.listLoading = true;
      api.getWeighingInBaseData().then((res) => {
        this.materialList = res.data.response.MaterialList;
        this.warehouseList = res.data.response.WarehouseList;
        this.supplierList = res.data.response.SupplierList;
        this.transportList = res.data.response.TransportList;
        this.placeOfOriginList = res.data.response.PlaceOfOriginList;
      });
    },
    selectWhsetting(id) {
      this.whsetting = this.whsettingListTop.filter((e) => e.Id == id)[0];
      window.localStorage.WhIn1Com = JSON.stringify(this.whsetting);
      if (this.whsetting.VideoUrl != "" && this.whsetting.VideoUrl != null) {
        this.VideoUrlList = this.whsetting.VideoUrl.split(",");
      } else {
        this.VideoUrlList = [];
      }
      this.initSocket(-1);
      if (this.whsetting.CameraUrl && this.whsetting.Cameras) {
        this.getCamera();
      }
      if (this.whsetting.Photos && this.whsetting.CameraUrl) {
        this.showPhotoBtn = true;
      } else {
        this.showPhotoBtn = false;
      }
      this.getweight();
    },
    selectMaterial(id) {
      var itemMat = this.materialList.filter((e) => e.Id == id)[0];
      this.editForm.MatName = itemMat.Name;
      this.editForm.MatGrade = itemMat.MatGrade;
      this.editForm.MatID = id;
      this.editForm.CubRate = itemMat.CubRate;
      this.NetWeightCount();
    },
    selectWarehouse(id) {
      var itemWarehouse = this.warehouseList.filter((e) => e.Id == id)[0];
      this.editForm.WarehouseName = itemWarehouse.Name;
      this.editForm.WarehouseID = id;
    },
    selectSupplier(name) {
      var itemSupplier = this.supplierList.filter((e) => e.Name == name);
      if (itemSupplier && itemSupplier.length > 0) {
        this.editForm.SupplierID = itemSupplier[0].Id;
      } else {
        this.editForm.SupplierID = 0;
      }
      this.editForm.SupplierName = name;
    },
    selectTransport(name) {
      var itemTransport = this.transportList.filter((e) => e.Name == name);
      if (itemTransport && itemTransport.length > 0) {
        this.editForm.TransportID = itemTransport[0].Id;
      } else {
        this.editForm.TransportID = 0;
      }
      this.editForm.TransportName = name;
    },
    selectPlaceOfOrigin(name) {
      var itemPlaceOfOrigin = this.placeOfOriginList.filter(
        (e) => e.Name == name
      );
      if (itemPlaceOfOrigin && itemPlaceOfOrigin.length > 0) {
        this.editForm.PlaceOfOriginID = itemPlaceOfOrigin[0].Id;
      } else {
        this.editForm.PlaceOfOriginID = 0;
      }
      this.editForm.PlaceOfOriginName = name;
    },
    addGross() {
      this.editForm.GrossWeight = this.whnumber;
      //this.Status = 0;
      this.getShot(0);
      this.NetWeightCount();
    },
    addTare() {
      this.editForm.TareWeight = this.whnumber;
      this.editForm.TareTime = null;
      //this.Status = 100;
      this.getShot(1);
      this.NetWeightCount();
    },
    getLastTareWeight() {
      this.editForm.TareWeight = this.lastTareWeight;
      this.editForm.TareTime = this.lastTareTime;
      this.getShot(1);
      this.NetWeightCount();
    },
    saveForm() {
      this.editForm.WeightID = this.whsetting.Id;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editWeighingIn(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.cancel();
                  this.getWeighingIn();
                  this.GetWeighingInBaseData();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          } else {
            api
              .addWeighingIn(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.cancel();
                  this.getWeighingIn();
                  this.GetWeighingInBaseData();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
        }
      });
    },
    //计算净重
    NetWeightCount() {
      var grossWeight =
        this.editForm.GrossWeight == "" ||
        this.editForm.GrossWeight == undefined
          ? 0
          : Number(this.editForm.GrossWeight);
      var tareWeight =
        this.editForm.TareWeight == "" || this.editForm.TareWeight == undefined
          ? 0
          : Number(this.editForm.TareWeight);
      var cubRate =
        this.editForm.CubRate == "" || this.editForm.CubRate == undefined
          ? 0
          : Number(this.editForm.CubRate);

      var buckleWeight =
        this.editForm.BuckleWeight == "" ||
        this.editForm.BuckleWeight == undefined
          ? 0
          : Number(this.editForm.BuckleWeight); //扣重1 扣重(kg)
      var deductionRate =
        this.editForm.DeductionRate == "" ||
        this.editForm.DeductionRate == undefined
          ? 0
          : Number(this.editForm.DeductionRate); //扣重2 扣重(%)

      this.editForm.NetWeight = Number(
        grossWeight - tareWeight - buckleWeight
      ).toFixed(2);
      var deductWeight2 = (
        (this.editForm.NetWeight * deductionRate) /
        100
      ).toFixed(0);
      this.editForm.NetWeight = this.editForm.NetWeight - deductWeight2;
      if (this.editForm.CubRate > 0) {
        this.editForm.DiscountQuantity = (
          Number(this.editForm.NetWeight) / cubRate
        ).toFixed(2);
      }
      //对方毛重
      var otherGrossWeight =
        this.editForm.OtherGrossWeight == "" ||
        this.editForm.OtherGrossWeight == undefined
          ? 0
          : Number(this.editForm.OtherGrossWeight);
      //对方皮重
      var otherTareWeight =
        this.editForm.OtherTareWeight == "" ||
        this.editForm.OtherTareWeight == undefined
          ? 0
          : Number(this.editForm.OtherTareWeight);
      this.editForm.OtherNetWeight = otherGrossWeight - otherTareWeight;

      this.editForm.NetWeightDifference =
        this.editForm.OtherNetWeight - this.editForm.NetWeight;
    },
    //获取磅秤数值
    getweight() {
      if (this.whsetting.WeightSocketUrl) {
        this.weightSocketInit();
        return;
      }
      if (this.weightInAuto) {
        clearTimeout(this.weightInAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        try {
          let opts = { timeout: 3000 };
          originJSONP(this.whsetting.WcfUrl, opts, (err, data) => {
            if (data && data.length > 0 && data[0].Weight > 0) {
              //如果原先是伪休眠状态,则需要重开任务,以200ms的速度运行
              if (this.outtime === 3000) {
                this.outtime = 200;
              }
              this.whnumber = data[0].Weight;
            } else {
              if (this.outtime !== 3000) {
                this.outtime = 3000;
              }
              this.whnumber = 0;
            }
            this.weightInAuto = setTimeout(() => {
              this.getweight();
            }, this.outtime);
          });
        } catch {
          this.outtime = 3000;
          this.weightInAuto = setTimeout(() => {
            this.getweight();
          }, this.outtime);
        }
      }
    },
    weightSocketInit() {
      let that = this;
      if (
        this.weightSocket != undefined &&
        this.weightSocket &&
        this.weightSocket.readyState < 2
      ) {
        console.log("主动关闭磅秤连接...");
        this.weightSocket.close();
      }
      this.weightTimeOutObjFunc();
      //链接服务端
      this.weightSocket = new WebSocket(this.whsetting.WeightSocketUrl);
      //配置客户端连接成功的回调方法
      this.weightSocket.onopen = function (event) {
        console.log("磅秤打开中...");
      };
      //配置客户端处理消息的回调方法
      this.weightSocket.onmessage = function (event) {
        if (that && !that._isDestroyed) {
          if (that.isJSON(event.data)) {
            var data = JSON.parse(event.data);
            if (data && data.Weight > 0) {
              that.whnumber = data.Weight;
            } else {
              that.whnumber = 0;
            }
          } else {
            that.whnumber = 0;
          }
        } else {
          that.whnumber = 0;
          that.weightSocket.close();
        }
      };
      this.weightSocket.onerror = function (event) {
        console.log("磅秤连接失败...");
      };
      this.weightSocket.onclose = function (event) {
        console.log("磅秤服务端主动断开...");
      };
    },
    weightTimeOutObjFunc() {
      if (this.weightTimeoutObj) {
        clearTimeout(this.weightTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.weightTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          if (
            that.weightSocket != undefined &&
            that.weightSocket &&
            that.weightSocket.readyState != 3
          ) {
            //console.log("磅秤在线,发送检测包");
            try {
              that.weightSocket.send("ping");
            } catch {}
            //磅秤心跳检测包
            that.weightTimeOutObjFunc();
          } else {
            console.log("磅秤连接断开,重新初始化磅秤");
            that.weightSocketInit();
          }
        }
      }, 20000);
    },
    remoteMethod(query) {
      let para = {
        license: query,
      };
      api.getLicense(para).then((res) => {
        this.options = res.data.response.options;
      });
    },
    changeLicense(obj) {
      let para = {
        license: obj,
      };
      api.getLastWeighingIn(para).then((res) => {
        this.lastTareWeight = 0;
        this.lastTareTime = null;
        if (!res.data.response || res.data.response.Id == null) {
          return;
        }
        var histryDM = res.data.response;
        var thisDm = this.editForm;

        this.editForm = {
          MatID: histryDM.MatID,
          MatName: histryDM.MatName,
          MatGrade: histryDM.MatGrade,
          WarehouseID: histryDM.WarehouseID,
          WarehouseName: histryDM.WarehouseName,
          SupplierID: histryDM.SupplierID,
          SupplierName: histryDM.SupplierName,
          TransportID: histryDM.TransportID,
          TransportName: histryDM.TransportName,
          PlaceOfOriginID: histryDM.PlaceOfOriginID,
          PlaceOfOriginName: histryDM.PlaceOfOriginName,
          Code: thisDm.Code,
          Id: thisDm.Id,
          GrossWeight: thisDm.GrossWeight,
          TareWeight: thisDm.TareWeight,
          BuckleWeight: thisDm.BuckleWeight,
          DeductionRate: thisDm.DeductionRate,
          CubRate: thisDm.CubRate,
          DiscountQuantity: thisDm.DiscountQuantity,
          NetWeight: thisDm.NetWeight,
          OtherGrossWeight: thisDm.OtherGrossWeight,
          OtherNetWeight: thisDm.OtherNetWeight,
          License: thisDm.License,
          DiscountRatio: thisDm.DiscountRatio,
          OtherTareWeight: thisDm.OtherTareWeight,
          NetWeightDifference: thisDm.NetWeightDifference,
          Price: thisDm.Price,
          Amount: thisDm.Amount,
          TransportPrice: thisDm.TransportPrice,
          UnitID: thisDm.UnitID,
          UnitName: thisDm.UnitName,
          UnitConvertRate: thisDm.UnitConvertRate,
          GrossTime: thisDm.GrossTime,
          TareTime: thisDm.TareTime,
          PurchaseContractID: thisDm.PurchaseContractID,
          PurchaseContractCode: thisDm.PurchaseContractCode,
          CreateUser: thisDm.CreateUser,
          CreateUserID: thisDm.CreateUserID,
          CreateTime: thisDm.CreateTime,
          UpdateUser: thisDm.UpdateUser,
          UpdateUserID: thisDm.UpdateUserID,
          UpdateTime: thisDm.UpdateTime,
          Flag: thisDm.Flag,
          Remark: thisDm.Remark,
          Status: thisDm.Status,
          WeightType: thisDm.WeightType,
          WeightID: thisDm.WeightID,
          GrossImgPath: thisDm.GrossImgPath,
          TareImgPath: thisDm.TareImgPath,
          PurchaseDeductionRate: thisDm.PurchaseDeductionRate,
        };
        this.lastTareWeight = histryDM.TareWeight;
        this.lastTareTime = histryDM.TareTime;
        // if (this.editForm.TareWeight == 0) {
        //   this.editForm.TareWeight = histryDM.TareWeight;
        //  this.editForm.TareTime = histryDM.TareTime;
        //}
        if (histryDM.MatID) {
          this.selectMaterial(histryDM.MatID);
        }
      });
    },
    //视频初始化
    initSocket(indexNum) {
      var that = this;
      this.videoTimeOutObjFunc();
      if (indexNum < 0) {
        this.destroyed();
        for (var i = 0; i < this.VideoUrlList.length; i++) {
          //链接服务端
          this.socket[i] = new WebSocket(this.VideoUrlList[i]);
          this.socket[i].Id = i;
          //配置客户端连接成功的回调方法
          this.socket[i].onopen = function (event) {
            console.log("open...");
          };
          var message = "";
          //配置客户端处理消息的回调方法
          this.socket[i].onmessage = function (event) {
            // //创建FileReader对象，该对象时html5中的特有对象，详细用法可以//参照html5相关资料
            // var reader = new FileReader();
            // var index = event.currentTarget.Id;
            // //设置FileReader对象的读取文件回调方法
            // reader.onload = function (eve) {
            //   //判断文件是否读取完成
            //   if (eve.target.readyState == FileReader.DONE) {
            //     //读取文件完成后，创建img标签来显示服务端传来的字节数//组
            //     var img = document.getElementById("video_" + index);
            //     //读取文件完成后内容放在this===当前
            //     //fileReader对象的result属性中，将该内容赋值img标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
            //     img.src = this.result;
            //     //将标签添加到id为show的div中否则，即便是有img也看不见
            //     // document.getElementById("show") = img;
            //   }
            // };
            // //调用FileReader的readAsDataURL的方法自动就会触发onload事件
            // reader.readAsDataURL(event.data);
            //新方法
            var index = event.currentTarget.Id;
            if (event.data === "start!!!") {
              message = "";
            } else if (event.data === "end!!!") {
              if (that.isJSON(message)) {
                var obj = JSON.parse(message);
                if (obj.type == 0) {
                  var img = document.getElementById("video_" + index);
                  //读取文件完成后内容放在 this===当前
                  //fileReader 对象的 result 属性中，将该内容赋值 img 标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
                  if (obj.jpegstream && img && img.src) {
                    img.src = "data:image/jpg;base64," + obj.jpegstream;
                  }
                } else if (obj.type == 1) {
                  //prase_data(JSON.parse(message), 0);
                  message = "";
                  //var obj=JSON.parse(message);
                  //img_2.src = 'data:image/jpg;base64,' + obj.reco_result.full_image;
                }
              }
            } else {
              message += event.data;
            }
          };
          this.socket[i].onerror = function (event) {
            var index = event.currentTarget.Id;
            console.log("error...");
            if (that && !that._isDestroyed) {
              //Socket链接失败,五秒后重连
              setTimeout(() => {
                if (event.currentTarget.url == that.VideoUrlList[index]) {
                  that.initSocket(index);
                }
              }, 5000);
            }
          };
          this.socket[i].onclose = function (event) {
            var index = event.currentTarget.Id;
            console.log("close...");
          };
        }
      } else {
        //链接服务端
        if (this.socket[indexNum]) {
          this.socket[indexNum].close();
        }
        this.socket[indexNum] = new WebSocket(this.VideoUrlList[i]);
        this.socket[indexNum].Id = indexNum;
        //配置客户端连接成功的回调方法
        this.socket[indexNum].onopen = function (event) {
          console.log("open...");
        };
        var message = "";
        //配置客户端处理消息的回调方法
        this.socket[indexNum].onmessage = function (event) {
          // //创建FileReader对象，该对象时html5中的特有对象，详细用法可以//参照html5相关资料
          // var reader = new FileReader();
          // var index = event.currentTarget.Id;
          // //设置FileReader对象的读取文件回调方法
          // reader.onload = function (eve) {
          //   //判断文件是否读取完成
          //   if (eve.target.readyState == FileReader.DONE) {
          //     //读取文件完成后，创建img标签来显示服务端传来的字节数//组
          //     var img = document.getElementById("video_" + index);
          //     //读取文件完成后内容放在this===当前
          //     //fileReader对象的result属性中，将该内容赋值img标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
          //     img.src = this.result;
          //     //将标签添加到id为show的div中否则，即便是有img也看不见
          //     // document.getElementById("show") = img;
          //   }
          // };
          // //调用FileReader的readAsDataURL的方法自动就会触发onload事件
          // reader.readAsDataURL(event.data);
          //新方法
          var index = event.currentTarget.Id;
          if (event.data === "start!!!") {
            message = "";
          } else if (event.data === "end!!!") {
            if (that.isJSON(message)) {
              var obj = JSON.parse(message);
              if (obj.type == 0) {
                var img = document.getElementById("video_" + index);
                //读取文件完成后内容放在 this===当前
                //fileReader 对象的 result 属性中，将该内容赋值 img 标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
                if (obj.jpegstream && img && img.src) {
                  img.src = "data:image/jpg;base64," + obj.jpegstream;
                }
              } else if (obj.type == 1) {
                //prase_data(JSON.parse(message), 0);
                message = "";
                //var obj=JSON.parse(message);
                //img_2.src = 'data:image/jpg;base64,' + obj.reco_result.full_image;
              }
            }
          } else {
            message += event.data;
          }
        };
        this.socket[indexNum].onerror = function (event) {
          var index = event.currentTarget.Id;
          console.log("error...");
          //Socket链接失败,五秒后重连
          setTimeout(() => {
            if (event.currentTarget.url == that.VideoUrlList[index]) {
              that.initSocket(index);
            }
          }, 5000);
          //that.initSocket(index);
        };
        this.socket[indexNum].onclose = function (event) {
          var index = event.currentTarget.Id;
          console.log("close...");
        };
      }
    },
    //Socket释放
    destroyed() {
      // 销毁监听
      this.socket.map((e) => {
        if (e != undefined && e && e.readyState < 2) {
          e.close();
        }
      });
    },
    videoTimeOutObjFunc() {
      if (this.videoTimeoutObj) {
        clearTimeout(this.videoTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.videoTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          that.socket.map((item, index) => {
            //视频心跳检测包
            if (item != undefined && item && item.readyState != 3) {
              //console.log("视频在线,发送检测包");
              try {
                item.send("ping");
              } catch {}
            } else {
              console.log("视频连接断开,重新初始化视频");
              that.initSocket(index);
            }
          });
          that.videoTimeOutObjFunc();
        }
      }, 30000);
    },
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    //摄像头识别车牌初始化
    getCamera() {
      if (this.whsetting.CameraSocketUrl) {
        this.cameraSocketInit();
        return;
      }
      if (this.weightCameraInAuto) {
        clearTimeout(this.weightCameraInAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        try {
          originJSONP(
            this.whsetting.CameraUrl +
              "/License?cameraIDList=" +
              this.whsetting.Cameras,
            null,
            (err, data) => {
              if (data && data.length > 0) {
                //for (var i = 0; i < data.length; i++) {
                if (data[0].License && this.lastLicense != data[0].License) {
                  this.editForm.License = data[0].License;
                  this.lastLicense = data[0].License;
                  this.changeLicense(this.editForm.License);
                }
              }
              //}
              this.weightCameraInAuto = setTimeout(() => {
                this.getCamera();
              }, 3000);
            }
          );
        } catch {
          this.weightCameraInAuto = setTimeout(() => {
            this.getCamera();
          }, 3000);
        }
      }
    },
    cameraSocketInit() {
      let that = this;
      if (
        this.cameraSocket != undefined &&
        this.cameraSocket &&
        this.cameraSocket.readyState < 2
      ) {
        console.log("主动关闭摄像头连接...");
        this.cameraSocket.close();
      }
      this.cameraTimeOutObjFunc();
      //链接服务端
      this.cameraSocket = new WebSocket(this.whsetting.CameraSocketUrl);
      //配置客户端连接成功的回调方法
      this.cameraSocket.onopen = function (event) {
        console.log("摄像头连接打开中...");
      };
      //配置客户端处理消息的回调方法
      this.cameraSocket.onmessage = function (event) {
        if (that && !that._isDestroyed) {
          if (that.isJSON(event.data)) {
            var data = JSON.parse(event.data);
            if (data && data.License) {
              if (data.License && that.lastLicense != data.License) {
                that.editForm.License = data.License;
                that.lastLicense = data.License;
                that.changeLicense(that.editForm.License);
              }
            }
          }
        } else {
          that.cameraSocket.close();
        }
      };
      this.cameraSocket.onerror = function (event) {
        console.log("摄像头连接失败...");
      };
      this.cameraSocket.onclose = function (event) {
        console.log("摄像头被服务器断开...");
      };
    },
    cameraTimeOutObjFunc() {
      if (this.cameraTimeoutObj) {
        clearTimeout(this.cameraTimeoutObj);
      }
      var that = this;
      //每二十秒检测一次Socket在线状态,在线则发送Send心跳包
      this.cameraTimeoutObj = setTimeout(() => {
        if (that && !that._isDestroyed) {
          //摄像头心跳检测包
          if (
            that.cameraSocket != undefined &&
            that.cameraSocket &&
            that.cameraSocket.readyState != 3
          ) {
            //console.log("摄像头在线,发送检测包");
            try {
              that.cameraSocket.send("ping");
            } catch {}
            that.cameraTimeOutObjFunc();
          } else {
            console.log("摄像头连接断开,重新初始化摄像头");
            that.cameraSocketInit();
          }
        }
      }, 20000);
    },
    //拍照
    //whtype:0过毛，1 过皮
    getShot(whType) {
      var opts = { timeout: 6000 };
      if (this.whsetting.Photos && this.whsetting.CameraUrl) {
        this.editLoading = true;
        originJSONP(
          this.whsetting.CameraUrl +
            "/Shot?cameraIDList=" +
            this.whsetting.Photos,
          opts,
          (err, data) => {
            this.editLoading = false;
            if (data && data.length > 0) {
              if (whType == 0) {
                this.shotGList = [];
              } else {
                this.shotTList = [];
              }
              if (whType == 0) {
                this.editForm.GrossImgPath = JSON.stringify(data);
              } else {
                this.editForm.TareImgPath = JSON.stringify(data);
              }
              data.map((e) => {
                e.FilePath = BaseApiUrl + "/" + e.FilePath;
                if (whType == 0) {
                  this.shotGList.push(e);
                } else {
                  this.shotTList.push(e);
                }
              });
            }
          }
        );
      }
    },
    conPa() {
      this.wechatCode = this.$route.query.code;
      this.wechatStatus = this.$route.query.state;
    },
    clearNum() {
      this.editForm.License = "";
      this.showTyper = 0;
    },
    onTypewriting: function () {
      // 点击输入框时，弹出键盘
      this.showTyper = 1;
      this.changeTyper();
    },
    changeTyper: function () {
      // 判断输入的车牌号处于什么状态，为空？已输入第一个值（即省）？输入省之后的值？
      if (this.editForm.License.length >= 1) {
        this.showTyper = 2;
      }
      if (this.editForm.License.length === 0) {
        this.showTyper = 1;
      }
    },
    input: function (item) {
      // 键盘点击事件，传入键盘本身的值
      if (item === "确认" || item === "关闭") {
        // 判断是否点击了关闭按钮
        this.showTyper = 0;
        return;
      }
      if (item === "删除") {
        // 判断是否点击了删除按钮
        this.editForm.License = this.editForm.License.slice(0, -1);
        this.changeTyper();
        return;
      }
      if (this.editForm.License.length < 8) {
        // 判断当前的车牌号的数目是否合法，还未超出7位则可继续输入
        this.editForm.License = this.editForm.License + item;
        this.changeTyper();
        this.changeLicense(this.editForm.License);
      } else {
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getWhsettingDetail();
    this.GetWeighingInBaseData();
    this.getWeighingIn();
  },
  created() {
    this.conPa();
  },
};
</script>

<style scoped>
.flex-row {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-row.between {
  justify-content: space-between;
}

.flex-row.wrap {
  flex-wrap: wrap;
}

.editForm .el-select {
  width: 100%;
}

.number {
  height: 100px;
  width: 80%;
  line-height: 100px;
  text-align: center;
  font-size: 5rem;
  background: rgb(247, 244, 229);
  border: 2px solid rgb(191, 169, 46);
  margin: 20px auto;
}

.overflow-auto {
  height: 55vh;
  overflow-y: scroll;
}

.rigth-card {
  margin-top: 10px;
}

.rigth-card /deep/.el-card__body {
  padding: 5px !important;
}

.rigth-card:nth-of-type(2n) {
  margin-left: 20px;
}

.weigth {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}

.weigth > div {
  width: 25%;
  font-size: 14px;
  padding: 4px;
  margin: 0 1px;
  text-align: center;
  box-shadow: 0 0 15px -6px;
}

.weigth > div:nth-of-type(1) {
  color: #67c23a;
}

.weigth > div:nth-of-type(2) {
  color: #409eff;
}

.weigth > div:nth-of-type(3) {
  color: #f56c6c;
}

.weigth > div > div:first-of-type {
  margin-bottom: 5px;
}

.rigth-card .el-form-item {
  margin-bottom: 0;
}
</style>
